export type ClassValue = string | false | null | undefined;

/** Tiny className joiner. */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}